import {
    // FILE_UPLOAD,
    CREATE_ADMIN_SHARED_ACCESS,
    RETRIEVE_ADMIN_SHARED_ACCESS,
    // RETRIEVE_ARCHITECTURECOMPANYCONVERTEDLEADS,
    // RETRIEVE_ARCHITECTURECOMPANYPENDINGLEADS,
    RETRIEVESINGLE_ADMIN_SHARED_ACCESS,
    UPDATE_ADMIN_SHARED_ACCESS,
    DELETE_ADMIN_SHARED_ACCESS,
    // RETRIEVE_ARCHITECTURESERVERSTAFF,
    // RETRIEVE_ARCHITECTURESERVERSERVICEUSERS,
} from "./type";
import AdminSharedAccess from "../service/AdminSharedAccess";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await AdminSharedAccess.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await AdminSharedAccess.create(data);
        dispatch({
            type: CREATE_ADMIN_SHARED_ACCESS,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await AdminSharedAccess.fetchList(data);
        dispatch({
            type: RETRIEVE_ADMIN_SHARED_ACCESS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await AdminSharedAccess.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ADMIN_SHARED_ACCESS,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await AdminSharedAccess.update(data);
        dispatch({
            type: UPDATE_ADMIN_SHARED_ACCESS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await AdminSharedAccess.changeStatus(data);
//         dispatch({
//             type: UPDATE_ADMIN_SHARED_ACCESS,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await AdminSharedAccess.trash(data);
        dispatch({
            type: DELETE_ADMIN_SHARED_ACCESS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};